module.exports = __webpack_public_path__ + "img/icon_black_pin_location.78154391.svg";